import { t } from "../services/utils";
export default {
  MONTHLY: 1,
  WEEKLY: 2,
  YEARLY: 3,
  THREE_MONTHLY: 4,
  SIX_MONTHLY: 5
};